import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { StubPage } from '#/components/stub-page'

export const Route = createFileRoute(
  '/_authed/accounts/$accountId/workspaces/$workspaceId/review',
)({
  component: WorkspaceReview,
})

function WorkspaceReview() {
  const { t } = useTranslation()
  return (
    <StubPage
      title={t('workspace.review')}
      description={t('workspace.reviewComingSoon')}
    />
  )
}
